/* 
  FeePreference - API Object
  {
    "feeName": "AKtestFee",
    "startDate": "2018-01-01T00:00:00Z",
    "endDate": "2035-01-01T00:00:00Z",
    "payType": 0,
    "isEnabled": "True"
  }
*/
export const normalizeFee = ({ isEnabled, feeName, payType }) => ({
  feeName,
  payType,
  isEnabled
});

/* 
StatePreference - API Object
{
  "state": "AK",
  "feeType": "License Plate",
  "startDate": "2013-06-01T05:00:00Z",
  "endDate": "2035-06-01T05:00:00Z",
  "feeNamePreferences": [ FeePreference, ... ]
}
*/
/**
 *
 * @returns preferencesByType - An object with the form {
 *   [feeType]: {
 *     startDate: Date,
 *     endDate: Date,
 *     preferences: [{feeName, payType, isEnabled}, ...]
 *   }
 * }
 */
export const groupByFeeType = statePreferences => {
  return statePreferences.reduce(
    (acc, { feeType, feeNamePreferences, startDate, endDate }) => ({
      ...acc,
      [feeType]: {
        startDate: new Date(startDate),
        endDate: new Date(endDate),
        preferences: feeNamePreferences.map(normalizeFee)
      }
    }),
    {}
  );
};

export const filterByState = (state, statePreference) =>
  statePreference.state === state;
